import { useEffect, useState } from 'react'

export const useUserLocation = (enabled: boolean) => {
  const [location, setLocation] = useState<[number, number] | null>(null)

  useEffect(() => {
    if (!enabled || !('geolocation' in navigator)) return

    const watchId = navigator.geolocation.watchPosition(
      (position) => {
        setLocation([position.coords.longitude, position.coords.latitude])
      },
      (error) => {
        console.error('Error getting location:', error)
      },
      {
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 60000,
      }
    )

    return () => {
      navigator.geolocation.clearWatch(watchId)
    }
  }, [enabled])

  return location
}
